"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.parse-float.js");

var _scrollbar = _interopRequireDefault(require("element-ui/lib/scrollbar"));

// 扩展
var TYPE_CLASSES_MAP = {
  success: 'el-icon-success',
  warning: 'el-icon-warning',
  error: 'el-icon-error'
};

var __vue_render__ = function __vue_render__(h) {
  var _vm = this;

  var _h = _vm.$createElement;
  var _c = h;
  return _c('transition', {
    attrs: {
      "name": "el-alert-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }],
    staticClass: "el-alert",
    "class": [_vm.typeClass, _vm.center ? 'is-center' : ''],
    attrs: {
      "role": "alert"
    }
  }, [_vm.showIcon ? _c('i', {
    staticClass: "el-alert__icon",
    "class": [_vm.iconClass, _vm.isBigIcon],
    attrs: {}
  }) : _vm._e(), _vm._v(" "), _vm.hasScrollbar ? _c('div', {
    staticClass: "el-alert__content",
    style: [_vm._px2rem(_vm.contentStyle, 24, [])],
    attrs: {}
  }, [_c('el-scrollbar', {
    ref: "scrollbar",
    attrs: {
      "wrap-style": [_vm.wrapStyle]
    }
  }, [typeof _vm.title === 'string' ? [!_vm.dangerouslyUseHTMLString ? _c('span', {
    staticClass: "el-alert__title",
    "class": [_vm.isBoldTitle],
    attrs: {}
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _vm.dangerouslyUseHTMLString ? _c('span', {
    staticClass: "el-alert__title",
    "class": [_vm.isBoldTitle],
    attrs: {},
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e()] : _vm.title instanceof Array ? [_c('div', {
    staticClass: "el-alert__title",
    "class": [_vm.isBoldTitle],
    attrs: {}
  }, _vm._l(_vm.title, function (t, i) {
    return _c('div', {
      key: i,
      attrs: {}
    }, [_vm._v(_vm._s(t))]);
  }))] : _vm._e(), _vm._v(" "), _vm._t("default", [_vm.description ? _c('p', {
    staticClass: "el-alert__description",
    attrs: {}
  }, [_vm._v(_vm._s(_vm.description))]) : _vm._e()], {})], 2), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.closable,
      expression: "closable"
    }],
    staticClass: "el-alert__closebtn",
    "class": {
      'is-customed': _vm.closeText !== '',
      'el-icon-close': _vm.closeText === ''
    },
    attrs: {},
    on: {
      "click": function click($event) {
        _vm.close();
      }
    }
  }, [_vm._v(_vm._s(_vm.closeText))])], 1) : _c('div', {
    staticClass: "el-alert__content",
    attrs: {}
  }, [typeof _vm.title === 'string' ? [!_vm.dangerouslyUseHTMLString ? _c('span', {
    staticClass: "el-alert__title",
    "class": [_vm.isBoldTitle],
    attrs: {}
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _vm.dangerouslyUseHTMLString ? _c('span', {
    staticClass: "el-alert__title",
    "class": [_vm.isBoldTitle],
    attrs: {},
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e()] : _vm.title instanceof Array ? [_c('div', {
    staticClass: "el-alert__title",
    "class": [_vm.isBoldTitle],
    attrs: {}
  }, _vm._l(_vm.title, function (t, i) {
    return _c('div', {
      key: i,
      attrs: {}
    }, [_vm._v(_vm._s(t))]);
  }))] : _vm._e(), _vm._v(" "), _vm._t("default", [_vm.description ? _c('p', {
    staticClass: "el-alert__description",
    attrs: {}
  }, [_vm._v(_vm._s(_vm.description))]) : _vm._e()], {}), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.closable,
      expression: "closable"
    }],
    staticClass: "el-alert__closebtn",
    "class": {
      'is-customed': _vm.closeText !== '',
      'el-icon-close': _vm.closeText === ''
    },
    attrs: {},
    on: {
      "click": function click($event) {
        _vm.close();
      }
    }
  }, [_vm._v(_vm._s(_vm.closeText))])], 2)])]);
};

var __vue_staticRenderFns__ = [];
var _default = {
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__,
  name: 'ElAlert',
  components: {
    ElScrollbar: _scrollbar["default"]
  },
  props: {
    title: {
      type: [String, Array],
      "default": '',
      required: true
    },
    description: {
      type: String,
      "default": ''
    },
    type: {
      type: String,
      "default": 'info'
    },
    closable: {
      type: Boolean,
      "default": true
    },
    dangerouslyUseHTMLString: {
      type: Boolean,
      "default": true
    },
    closeText: {
      type: String,
      "default": ''
    },
    showIcon: Boolean,
    center: Boolean,
    controlled: Boolean,
    // 扩展scrollbar
    hasScrollbar: Boolean,
    maxHeight: [String, Number] // 扩展scrollbar

  },
  data: function data() {
    return {
      visible: true
    };
  },
  methods: {
    close: function close() {
      if (!this.controlled) {
        this.visible = false;
      }

      this.$emit('close');
    }
  },
  computed: {
    typeClass: function typeClass() {
      return "el-alert--".concat(this.type);
    },
    iconClass: function iconClass() {
      return TYPE_CLASSES_MAP[this.type] || 'el-icon-info';
    },
    isBigIcon: function isBigIcon() {
      return this.description || this.$slots["default"] ? 'is-big' : '';
    },
    isBoldTitle: function isBoldTitle() {
      return this.description || this.$slots["default"] ? 'is-bold' : '';
    },
    // 扩展scrollbar
    wrapStyle: function wrapStyle() {
      return {
        height: '100%'
      };
    },
    contentStyle: function contentStyle() {
      return {
        'max-height': parseFloat(this.maxHeight) + 'px'
      };
    } // 扩展scrollbar

  }
};
exports["default"] = _default;